import { ErrorInfo } from "react";
import { trackedError } from "../../../common/events/reduxEventTracking";

export const actionCreators = {
    error: (error: Error, errorInfo: ErrorInfo) =>
        trackedError({ type: "APPLICATION/UNHANDLED_ERROR", error, errorInfo }),
};
